import React from 'react';
import { Signup } from '../../components/customAuth';

export function SignUpPage() {
  return (
    <div style={{ 
      minHeight: '80vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '2rem 0',
      // background: '#f5f5f5'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '600px', 
        padding: '0 1rem',
        marginBottom: '88px'
      }}>
        <div style={{ 
          background: 'white', 
          padding: '2rem', 
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <Signup />
        </div>
      </div>
    </div>
  );
}

